import axios from 'axios';

// 自动适配当前域名，支持开发和生产环境
const getAPIBaseURL = () => {
  // 如果有环境变量配置，优先使用
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // 生产环境：使用当前域名和协议
  if (process.env.NODE_ENV === 'production') {
    return `${window.location.protocol}//${window.location.host}`;
  }
  
  // 开发环境：使用localhost
  return 'http://localhost:8080';
};

const API_BASE_URL = getAPIBaseURL();

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// API 方法
export const authAPI = {
  login: (credentials) => api.post('/api/v1/auth/login', credentials),
  refreshToken: () => api.post('/api/v1/auth/refresh'),
};

export const scriptsAPI = {
  getScripts: () => api.get('/api/v1/admin/scripts'),
  createScript: (script) => api.post('/api/v1/admin/scripts', script),
  updateScript: (id, script) => api.put(`/api/v1/admin/scripts/${id}`, script),
  deleteScript: (id) => api.delete(`/api/v1/admin/scripts/${id}`),
};

export const domainsAPI = {
  getDomains: () => api.get('/api/v1/admin/domains'),
  createDomain: (domain) => api.post('/api/v1/admin/domains', domain),
  updateDomain: (id, domain) => api.put(`/api/v1/admin/domains/${id}`, domain),
  deleteDomain: (id) => api.delete(`/api/v1/admin/domains/${id}`),
};

export const statsAPI = {
  getOverview: (days = 7) => api.get(`/api/v1/admin/stats/overview?days=${days}`),
  getRealtime: () => api.get('/api/v1/admin/stats/realtime'),
  getDaily: (days = 30) => api.get(`/api/v1/admin/stats/daily?days=${days}`),
};

export const systemAPI = {
  getStatus: () => api.get('/api/v1/admin/system/status'),
  changePassword: (data) => api.post('/api/v1/admin/change-password', data),
  getGooglebotConfig: () => api.get('/api/v1/admin/googlebot-config'),
  updateGooglebotConfig: (config) => api.put('/api/v1/admin/googlebot-config', config),
};

export const substituteConfigsAPI = {
  getConfigs: () => api.get('/api/v1/admin/substitute-configs'),
  getConfig: (id) => api.get(`/api/v1/admin/substitute-configs/${id}`),
  createConfig: (config) => api.post('/api/v1/admin/substitute-configs', config),
  updateConfig: (id, config) => api.put(`/api/v1/admin/substitute-configs/${id}`, config),
  deleteConfig: (id) => api.delete(`/api/v1/admin/substitute-configs/${id}`),
};

export default api;
